export const SET_SITE_COLOR = 'SET_SITE_COLOR';
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';

export function setSiteColor(siteColor) {
    return { type: SET_SITE_COLOR, siteColor };
}

export function setSearchValue(searchValue) {
    return { type: SET_SEARCH_VALUE, searchValue };
}
